import React, { useEffect, useState, useRef } from 'react';
function useInView(threshold = 0.1) {
  const ref = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setInView(true);
    }, {
      threshold
    });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [threshold]);
  return {
    ref,
    inView
  };
}
const testimonials = [{
  name: 'Carmen R.',
  age: '52 años',
  location: 'Madrid',
  quote: 'Llevaba 2 años enviando CVs sin respuesta. En 6 semanas con el Método Fénix conseguí mi primer cliente digital a 35€/hora. Ahora tengo 3 clientes fijos y trabajo desde casa.',
  result: '+1.200€/mes',
  resultColor: '#4CAF50',
  initials: 'CR'
}, {
  name: 'Marta L.',
  age: '48 años',
  location: 'Barcelona',
  quote: 'Pensaba que la tecnología era mi enemiga. Resulta que mis 20 años gestionando equipos son exactamente lo que los emprendedores digitales necesitan y no encuentran en ningún lado.',
  result: 'Libertad total',
  resultColor: '#C9A84C',
  initials: 'ML'
}, {
  name: 'Ana P.',
  age: '55 años',
  location: 'Valencia',
  quote: 'Lo que más me sorprendió fue darme cuenta de que mi experiencia era mi mayor activo, no mi mayor problema. El mercado equivocado me rechazaba. El mercado correcto me busca.',
  result: 'Trabajo desde casa',
  resultColor: '#5B9BD5',
  initials: 'AP'
}];
export function TestimonialsSection() {
  const {
    ref,
    inView
  } = useInView();
  return <section className="section-cream py-20 lg:py-28" ref={ref} data-id="element-194">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-195">
        {/* Header */}
        <div className="text-center mb-16 transition-all duration-700" style={{
        opacity: inView ? 1 : 0,
        transform: inView ? 'translateY(0)' : 'translateY(30px)'
      }} data-id="element-196">
          <p className="font-body font-bold tracking-widest text-sm uppercase mb-3" style={{
          color: '#C9A84C'
        }} data-id="element-197">
            Resultados reales
          </p>
          <h2 className="font-heading font-black" style={{
          color: '#1B3A5C',
          fontSize: 'clamp(1.8rem, 4vw, 3rem)'
        }} data-id="element-198">
            Ellas Ya Dieron el Salto
          </h2>
        </div>

        {/* Testimonial cards */}
        <div className="grid md:grid-cols-3 gap-6" data-id="element-199">
          {testimonials.map((t, i) => <div key={t.name} className="flex flex-col p-6 rounded-2xl transition-all duration-700" style={{
          backgroundColor: '#FFFFFF',
          border: '1px solid #E0D8C8',
          boxShadow: '0 8px 30px rgba(27,58,92,0.1)',
          opacity: inView ? 1 : 0,
          transform: inView ? 'translateY(0)' : 'translateY(40px)',
          transitionDelay: `${200 + i * 150}ms`
        }} data-id="element-200">
              {/* Stars */}
              <div className="flex gap-1 mb-4" data-id="element-201">
                {[...Array(5)].map((_, j) => <span key={j} style={{
              color: '#C9A84C'
            }} data-id="element-202">
                    ★
                  </span>)}
              </div>

              {/* Quote */}
              <p className="font-body text-sm leading-relaxed flex-1 mb-6" style={{
            color: '#3A4A5A'
          }} data-id="element-203">
                "{t.quote}"
              </p>

              {/* Result badge */}
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-body font-black mb-4 self-start" style={{
            backgroundColor: `${t.resultColor}18`,
            border: `1px solid ${t.resultColor}40`,
            color: t.resultColor
          }} data-id="element-204">
                ✓ {t.result}
              </div>

              {/* Author */}
              <div className="flex items-center gap-3" data-id="element-205">
                <div className="w-10 h-10 rounded-full flex items-center justify-center font-body font-black text-sm flex-shrink-0" style={{
              backgroundColor: '#1B3A5C',
              color: '#C9A84C'
            }} data-id="element-206">
                  {t.initials}
                </div>
                <div data-id="element-207">
                  <p className="font-body font-bold text-sm" style={{
                color: '#1B3A5C'
              }} data-id="element-208">
                    {t.name}, {t.age}
                  </p>
                  <p className="font-body text-xs" style={{
                color: '#8A9AAA'
              }} data-id="element-209">
                    {t.location}
                  </p>
                </div>
              </div>
            </div>)}
        </div>

        {/* Pull quotes */}
        <div className="mt-16 transition-all duration-700 delay-600" style={{
        opacity: inView ? 1 : 0,
        transform: inView ? 'translateY(0)' : 'translateY(20px)'
      }} data-id="element-210">
          <div className="gold-divider mb-10" data-id="element-211" />
          <p className="font-body text-center text-sm uppercase tracking-widest mb-8" style={{
          color: '#8A9AAA'
        }} data-id="element-212">
            Lo que dicen sobre mujeres como tú
          </p>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-213">
            {['El mercado te llama "senior", yo te llamo el activo más escaso de la economía digital.', 'Invisible para las ETTs, Imprescindible para los negocios digitales.', 'No es falta de tecnología, es exceso de sabiduría.'].map((quote, i) => <div key={i} className="p-5 rounded-xl" style={{
            backgroundColor: '#FAF7F2',
            border: '1px solid rgba(201,168,76,0.3)'
          }} data-id="element-214">
                <p className="font-heading italic text-sm leading-relaxed" style={{
              color: '#1B3A5C'
            }} data-id="element-215">
                  "{quote}"
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}